export enum ECategoryVisibility {
    ANONYMOUS = 'anonymous',
    PUBLIC = 'public',
    OPTIONAL = 'optional',
    CONFIDENTIAL = 'confidential',
    ANY = 'any',
}